// import { fly } from './request'
let api = {

  //接口表
  qr_scan: '/qr/scan',    //
  security_query:'/qr/securityQuery',
  file_upload: '/file/upload',
  feedback:'/qr/feedback',
  ecat_product_overview: 'https://dpes.ea.dxtservice.com/api/ecat/product-details',
  ecat_tech_specification: 'https://dpes.ea.dxtservice.com/api/ecat/product-details',



  



}

export default {
  api,
}